import React from "react";
import "./button.css";

function Button({ variant = "default", size = "default", children, ...props }) {
  const classNames = [
    "button",
    variant && `button--${variant}`,
    size && `button--${size}`,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button className={classNames} {...props}>
      {children}
    </button>
  );
}

export default Button;
